import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getTeamRequest = async (id: number | string | undefined) => {
  const response: AxiosResponse = await apiInstance.get(`/teams/${id}`);

  return response.data;
};
